import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "@app/components/common";

export interface Props {
  provider: "facebook" | "twitter" | "linkedIn" | string;
  url: string;
}

export const SocialLink: FC<Props> = ({ provider, url }) => {
  const getIcon = () => {
    if (provider === "facebook") {
      return (
        <FontAwesomeIcon
          icon={faFacebookF}
          className={"h-[21px] w-[11px]"}
          color="#000"
        />
      );
    }
    if (provider === "youtube") {
      return (
        <FontAwesomeIcon
          icon={faYoutube}
          className={"h-[25px] w-[30px]"}
          color="#000"
        />
      );
    }

    if (provider === "twitter") {
      return (
        <StaticImage
          className={"h-[21px] w-[21px]"}
          src="./X.svg"
          alt="twitter"
        />
      );
    }

    if (provider === "linkedIn") {
      return (
        <StaticImage
          className={"h-[21px] w-[21px]"}
          src="./linkedin.png"
          alt="linkedIn"
        />
      );
    }

    if (provider === "instagram") {
      return (
        <StaticImage
          className={"h-[22px] w-[22px]"}
          src="./instagram.png"
          alt="instagram"
        />
      );
    }
  };

  return (
    <Link
      to={url}
      className={
        "flex h-12 w-12 items-center justify-center rounded-full bg-primary-content"
      }
    >
      {getIcon()}
    </Link>
  );
};
